module.exports = __webpack_public_path__ + "static/media/store-list.45cd0671.jpeg";